"use client";

import { RewardAverageCard } from "@/components/reward-average-card";

const DATA = [
  {
    color: "bg-bitcoin",
    cryptoName: "Bitcoin",
    cryptoSymbol: "BTC",
    percentage: 2.37,
    usdAmount: 2298.9,
  },
  {
    color: "bg-avalanche",
    cryptoName: "Avalanche",
    cryptoSymbol: "AVAX",
    percentage: 12.5,
    usdAmount: 4.375,
  },
  {
    color: "bg-dogecoin",
    cryptoName: "Dogecoin",
    cryptoSymbol: "DOGE",
    percentage: 112.85,
    usdAmount: 47.25,
  },
  {
    color: "bg-[#627EEA]",
    cryptoName: "Ethereum",
    cryptoSymbol: "ETH",
    percentage: 14.5,
    usdAmount: 333.5,
  },
  {
    color: "bg-[#A15BE6]",
    cryptoName: "Solana",
    cryptoSymbol: "SOL",
    percentage: 10,
    usdAmount: 24.5,
  },
  {
    color: "bg-usdc",
    cryptoName: "USD Coin",
    cryptoSymbol: "USDC",
    percentage: 24.5,
    usdAmount: 0.245,
  },
];

export function SuggestedRewards() {
  return (
    <div className="xs:grid-cols-2 grid grid-cols-1 gap-4 lg:grid-cols-3">
      {DATA.map((data, key) => (
        <RewardAverageCard key={key} {...data} />
      ))}
    </div>
  );
}
